import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=39f72bd0&scoped=true&lang=pug&"
import script from "./ModalAlert.vue?vue&type=script&lang=js&"
export * from "./ModalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f72bd0",
  null
  
)

export default component.exports